// Allow to be set from config so users can customise
export const PRICE_UPDATE_THROTTLE = 1000;
export const PRICE_UPDATE_TIMEOUT = 15000;
export const CG_BASE_API_URL = `${process.env.NEXT_PUBLIC_SERVICES_PROXY}/coingecko/api/v3`;
export const DEFAULT_PYTH_MARKET_HOUR_ENDPOINT = `${process.env.NEXT_PUBLIC_SERVICES_PROXY}/price-history/v1/price_feeds`;
